var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPortalApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#0033AD",
    d: "m0,32c0,-17.6731 14.3269,-32 32,-32c17.6731,0 32,14.3269 32,32c0,17.6731 -14.3269,32 -32,32c-17.6731,0 -32,-14.3269 -32,-32z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0,
    id: "svg_2",
    fill: "#FFFFFF",
    d: "m21.16694,23.50004l24.375,0l0,-2.83304l-24.375,0a2.71619,2.84154 0 0 0 -2.70888,2.83304l0,15.58298l-2.70806,0l0,4.24998l18.95806,0l0,-4.24998l-13.54112,0l0,-15.58298zm25.72862,2.83304l-8.125,0c-0.74425,0 -1.35362,0.6375 -1.35362,1.41694l0,14.16689c0,0.7786 0.60938,1.41609 1.35362,1.41609l8.125,0c0.74506,0 1.35444,-0.6375 1.35444,-1.41609l0,-14.16689c0,-0.77945 -0.60938,-1.41694 -1.35444,-1.41694zm-1.35362,12.74994l-5.41694,0l0,-9.91606l5.41694,0l0,9.91606z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPortalApi);
export default __webpack_public_path__ + "static/media/ic_portal-api.ad7441a1f27991c03fd521490028e22d.svg";
export { ForwardRef as ReactComponent };